module.exports = __webpack_public_path__ + "assets/img/客户案例—浙商证券.ae534d3b.png";